import { Loading, theme } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledListWrapper = styled.div`
  height: 100%;

  &[data-has-message='true'] {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  a {
    text-decoration: none;
  }

  .post-content-wrapper {
    padding: 0.5rem 0 1rem;
  }

  .post-reaction {
    .session-action {
      padding: 0;
    }
  }
`

export const StyledTabWrapper = styled.div`
  p {
    font-size: 14px !important;
  }
`

export const StyledWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 436px;
  background: white;
  z-index: 500;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.1);
`
export const StyledHeader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 18px;
  border-bottom: 1px solid #f3f3f3;
`
export const StyledHeading = styled.div`
  text-align: center;
  font-size: 18px;
  font-weight: 600;
`

export const StyledCloseBtn = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 67px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledBackBtn = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 67px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledLoginReminder = styled.div`
  padding: 0 16px 16px;
`

export const StyledLink = styled.a`
  color: ${theme.mbColors.pink};
  text-decoration: none;
`
export const StyledLoading = styled(Loading)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
